module.exports = __webpack_public_path__ + "img/no-head.2e04c31c.png";